<script setup>
import { useStatusStore } from "@/Stores/statusStore";
import {computed, watch} from "vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

const statusStore = useStatusStore();

const message = computed(() => {
    return statusStore?.getStatus()?.message;
})

watch(message, (newMessage, oldMessage) => {
    if (newMessage !== oldMessage) {
        statusStore.setDidDismissBanner(false);
    }
});

</script>

<template>
    <div v-if="message && !statusStore.getDidDismissBanner()" class=" bg-gray-900 py-1.5 sm:pr-3.5">
        <div class="mx-auto max-w-7xl flex items-center justify-between lg:px-12 px-4 ">
            <p class="text-sm sm:text-base leading-6 text-white">
                <strong class="font-semibold" v-html="message"></strong>
            </p>
            <button type="button" class=" flex-none p-3 focus-visible:outline-offset-[-4px]" @click="statusStore.setDidDismissBanner(true)">
                <span class="sr-only">Dismiss</span>
                <FontAwesomeIcon :icon="['fas', 'xmark']" class="mt-1 mr-2" size="sm" style="cursor: pointer; color: #ffffff;"/>
            </button>
        </div>
    </div>
</template>

<style scoped>

</style>
